import React, { PureComponent } from "react";
import { get, capitalize } from "lodash";

import { formatCurrency, formatSequencial } from "@tvg/formatter";
import RunnerNumber from "../../_atom/RunnerNumber";
import {
  PayoffRow,
  PayoffCell,
  RacePayoffsDesc,
  RacePayoffsPickDetail,
  Selections,
  Payoff,
  PayoffsPerSaddleContainer,
  PayoffsPerSaddleList,
  PayoffsPerSaddleItem,
  PayoutText,
  RunnerText,
  NewPayoff
} from "./styled-components";

const exoticSeparator = "-";
const pickSeparator = "-";
const positionSeparator = ",";
export const exoticsBet = [
  "WN",
  "PL",
  "SH",
  "WP",
  "WS",
  "PS",
  "WPS",
  "QN",
  "QNB",
  "QNW",
  "EX",
  "EKB",
  "EXB",
  "EXW",
  "EXK",
  "TR",
  "TRB",
  "TRW",
  "TRK",
  "TKB",
  "SU",
  "SUB",
  "SUK",
  "SUW",
  "SKB",
  "SH5",
  "H5W",
  "S5K",
  "5KB",
  "OM",
  "OMB",
  "OMW",
  "TI",
  "TIB",
  "TIW"
];
export const picksBet = [
  "DB",
  "GS",
  "P3",
  "P4",
  "P5",
  "P6",
  "P7",
  "P8",
  "P9",
  "P10",
  "A3",
  "A4",
  "A5",
  "A6",
  "A7",
  "A8",
  "A9",
  "A10",
  "L3",
  "L4",
  "L5",
  "L6",
  "L7",
  "L8",
  "L9",
  "L10",
  "E12",
  "SV"
];
export const formatPickResults = (raceNumberBase) => (pickNumber) =>
  `R${raceNumberBase + pickNumber}`;
const hasRacesSeparators = (selection, raceSeparator) =>
  RegExp(`[${raceSeparator}${positionSeparator}]`).test(selection);

export const parseResults = (selections, typeSeparator) =>
  selections
    .split(typeSeparator)
    .map((winners) => winners.split(positionSeparator));

export default class RaceResultsPayoff extends PureComponent {
  static defaultProps = {
    payoff: {
      wagerAmount: 0,
      wagerType: { code: "", name: "" },
      selections: [{ payoutAmount: 0, selection: "" }]
    },
    raceNumber: "1",
    raceTypeCode: "T",
    enableRaceResultsReDesign: false
  };

  renderSelections = (selections, wagerTypeCode) => {
    if (
      exoticsBet.includes(wagerTypeCode) &&
      hasRacesSeparators(selections, exoticSeparator)
    ) {
      const payoffsArr = parseResults(selections, exoticSeparator);
      return this.renderPayoffsList(payoffsArr, formatSequencial);
    }
    if (
      picksBet.includes(wagerTypeCode) &&
      hasRacesSeparators(selections, pickSeparator)
    ) {
     const payoffsArr = parseResults(selections, pickSeparator);
      return this.renderPayoffsList(
        payoffsArr,
        formatPickResults(+this.props.raceNumber - payoffsArr.length),
        true
      );
    }
    return this.renderPlainPayoffs(selections);
  };

  renderPayoffsList = (winners, cbText, isColRowLayout = false) => (
    <PayoffsPerSaddleContainer
      isVertical={isColRowLayout}
      data-qa-label="racePayoffs-row-selections"
    >
      {winners.map((winner, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Selections isVertical={!isColRowLayout} key={`winner_${index}`}>
          {cbText && (
            <PayoutText hasNewDesign={this.props.enableRaceResultsReDesign}>
              {cbText(index + 1)}
            </PayoutText>
          )}
          <PayoffsPerSaddleList>
            {winner.map((horse, position) => (
              // eslint-disable-next-line react/no-array-index-key
              <PayoffsPerSaddleItem key={`winner_${index}_${position}`}>
                {isNaN(horse) ? (
                  <RunnerText>{horse}</RunnerText>
                ) : (
                  <RunnerNumber
                    runnerId={horse}
                    raceTypeCode={this.props.raceTypeCode}
                  />
                )}
              </PayoffsPerSaddleItem>
            ))}
          </PayoffsPerSaddleList>
        </Selections>
      ))}
    </PayoffsPerSaddleContainer>
  );

  renderPlainPayoffs = (text) => (
    <PayoffsPerSaddleContainer data-qa-label="racePayoffs-row-selections">
      {text}
    </PayoffsPerSaddleContainer>
  );

   renderWithHorseSaddlecloth() {
    const selectionsRaw = get(this.props.payoff, "selections[0].selection");
    const wagerTypeCode = get(this.props.payoff, "wagerType.code");

    const pickRegex = /^\s*(\d+)\s*of\s*(\d+)\s+/i;
    const match = selectionsRaw.match(pickRegex);

    const pickStr = match ? match[0].trim().toUpperCase() : null;

    const selections = match
      ? selectionsRaw.slice(match[0].length)
      : selectionsRaw;

    return (
      <PayoffRow
        hasNewDesign={this.props.enableRaceResultsReDesign}
        data-qa-label="racePayoffs-row"
      >
        <PayoffCell hasNewDesign={this.props.enableRaceResultsReDesign}>
          <span>
            <RacePayoffsDesc data-qa-label="racePayoffs-row-betAmount">
              {`${formatCurrency(get(this.props.payoff, "wagerAmount"))} `}
            </RacePayoffsDesc>
            <RacePayoffsDesc data-qa-label="racePayoffs-row-wagerType">
              {`${capitalize(get(this.props.payoff, "wagerType.name", ""))}`}
            </RacePayoffsDesc>
            {pickStr && (
              <RacePayoffsPickDetail>({pickStr})</RacePayoffsPickDetail>
            )}
          </span>
          {selections !== "Refund" &&
            this.renderSelections(selections, wagerTypeCode, pickStr)}
        </PayoffCell>
        <PayoffCell hasNewDesign={this.props.enableRaceResultsReDesign}>
          <NewPayoff data-qa-label="racePayoffs-row-payoutAmount">
            {selections !== "Refund"
              ? formatCurrency(
                  get(this.props.payoff, "selections[0].payoutAmount")
                )
              : "Refund"}
          </NewPayoff>
        </PayoffCell>
      </PayoffRow>
    );
  }

  renderPlainResults() {
    const selections = get(this.props.payoff, "selections[0].selection");
    return (
      <PayoffRow data-qa-label="racePayoffs-row">
        <PayoffCell>
          <span>
            <span data-qa-label="racePayoffs-row-betAmount">
              {`${formatCurrency(get(this.props.payoff, "wagerAmount"))} `}
            </span>
            <span data-qa-label="racePayoffs-row-wagerType">
              {get(this.props.payoff, "wagerType.name")}
            </span>
          </span>
          {selections !== "Refund" && (
            <Selections data-qa-label="racePayoffs-row-selections">
              {selections}
            </Selections>
          )}
        </PayoffCell>
        <PayoffCell>
          <Payoff data-qa-label="racePayoffs-row-payoutAmount">
            {selections !== "Refund"
              ? formatCurrency(
                  get(this.props.payoff, "selections[0].payoutAmount")
                )
              : "Refund"}
          </Payoff>
        </PayoffCell>
      </PayoffRow>
    );
  }

  render() {
    return this.props.enableRaceResultsReDesign
      ? this.renderWithHorseSaddlecloth()
      : this.renderPlainResults();
  }
}
